import React from 'react';
import { Loader, BaasicInput, BaasicSelect, DatePicker, BaasicDropdown } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const MarketplaceOrderEditOrderStepTemplate = ({
	t,
	marketplaceOrderEditViewStore: {
		form,
		loading,
		onSelectChange,
		orderTypeOptions,
		datePickerFormat,
		channelOptions,
		orderStatusOptions,
		debouncedOrderStatusSearch,
		debouncedOrderTypeSearch,
		isOrderStatusLoading,
		isOrderTypeLoading,
		onMenuClose,
		sellerDropdownStore,
		isSuperAdmin,
		isEdit,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<h3 className="spc--bottom--med title--primary">{t('MARKETPLACEORDEREDITFORM.TITLE.ORDERSTEP')}</h3>
			<div className="row">
				<div className="col col-sml-12 col-lrg-12 col-xxlrg-8">
					<div className="spc--bottom--sml">
						{isSuperAdmin && (
							<BaasicDropdown
								dropdownStore={sellerDropdownStore}
								placeholder={t('PLACEHOLDER.SELLER')}
								className="w--200--px spc--right--sml"
								isDisabled={isEdit}
							/>
						)}
					</div>
					<div className="row">
						<div className="col col-sml-6">
							<BaasicInput autoFocus field={form.$('orderStep.orderNumber')} />
							<div className="spc--bottom--sml">
								<DatePicker field={form.$('orderStep.orderDate')} format={datePickerFormat} />
							</div>
							<div className="spc--bottom--sml">
								<DatePicker field={form.$('orderStep.shipByDate')} format={datePickerFormat} />
							</div>
							<div className="spc--bottom--sml">
								<DatePicker field={form.$('orderStep.paymentDate')} format={datePickerFormat} />
							</div>
							<div className="spc--bottom--sml">
								<DatePicker field={form.$('orderStep.deliverByDate')} format={datePickerFormat} />
							</div>
							<BaasicSelect
								field={form.$('orderStep.orderType')}
								value={form.$('orderStep.orderType').value}
								onChange={value => onSelectChange(value, form.$('orderStep.orderType'))}
								options={orderTypeOptions}
								className="spc--bottom--sml flex--grow--1"
								onInputChange={debouncedOrderTypeSearch}
								onMenuClose={() => onMenuClose()}
								isLoading={isOrderTypeLoading}
							/>
						</div>
						<div className="col col-sml-6">
							<BaasicInput field={form.$('orderStep.internalNote')} />
							<BaasicInput field={form.$('orderStep.ref1')} />
							<BaasicInput field={form.$('orderStep.ref2')} />
							<BaasicInput field={form.$('orderStep.ref3')} />
							{channelOptions.length > 1 && (
								<BaasicSelect
									field={form.$('orderStep.channel')}
									value={form.$('orderStep.channel').value}
									options={channelOptions}
									onChange={value => onSelectChange(value, form.$('orderStep.channel'))}
									className="spc--bottom--sml flex--grow--1"
								/>
							)}
							<BaasicSelect
								field={form.$('orderStep.orderStatus')}
								value={form.$('orderStep.orderStatus').value}
								options={orderStatusOptions.slice()}
								onChange={value => onSelectChange(value, form.$('orderStep.orderStatus'))}
								className="spc--bottom--sml flex--grow--1"
								onInputChange={debouncedOrderStatusSearch}
								onMenuClose={() => onMenuClose()}
								isLoading={isOrderStatusLoading}
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default defaultTemplate(MarketplaceOrderEditOrderStepTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/wizard/MarketplaceOrderEditOrderStepTemplate.jsx